<template>
  <el-dialog
    ref="tgc"
    title="选择三包登记单进行引用"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    size="auto">
        <el-table
            ref="refTable"
            v-loading = "loadingData"
            :data="quotes"
            border
            style="width: 100%"
            max-height="350">
            <el-table-column label="" width="50" align="right">
                <template slot-scope="scope">
                    <el-radio :disabled="parseInt(scope.row.is_yinyong) === 1" v-model="radio" :label="scope.row.guanlian_transaction_no"  @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
                </template>
            </el-table-column>
            <el-table-column
                prop="is_yinyong"
                label="引用状态"
                :formatter="formatter"
                width="60">
            </el-table-column>
            <el-table-column
            prop="guanlian_transaction_no"
            label="登记单号"
            width="150">
            </el-table-column>
            <el-table-column
            prop="work_time"
            label="登记日期"
            width="90">
            </el-table-column>
            <el-table-column
            prop="piaoju_no"
            label="收胎票据号"
            width="90">
            </el-table-column>
            <el-table-column
            prop="customer.customer_name"
            label="客户名称"
            width="250">
            </el-table-column>
            <el-table-column
            prop="jingying_name"
            label="经营团队"
            width="60">
            </el-table-column>
            <el-table-column
            prop="pici"
            label="批次"
            width="90">
            </el-table-column>
        </el-table>
        <!-- <el-input @change="onFocus" :rows="10" :placeholder="example" v-model="inputText" type="textarea" ></el-input> -->
        <template slot='footer'>
        <span  class="dialog-footer">
            <!-- <el-button @click="cancel">{{cancelText}}</el-button>
            <el-button type="primary" @click="onConfirm">{{comfirmText}}</el-button> -->
            <el-row align="middle" type="flex">
                <el-col :span="5"><el-button :disabled="!currentRef" @click="addRef" type="primary">添加选中项</el-button></el-col>
                <el-col :span="5"><el-checkbox v-model="hiddenRef">隐藏引用完成项</el-checkbox></el-col>
                <el-col :span="14">
                    <el-pagination
                        v-if="quotes.length > 0"
                        small
                        :page-size="pagesize"
                        :current-page="currentPage"
                        @current-change="queryData"
                        layout="prev, pager, next"
                        :total="totalPage">
                    </el-pagination>
                </el-col>
            </el-row>
        </span>
        </template>
    </el-dialog>
</template>
<script>
/**
 * 三包引用
 * @author welpher
 * registerId   在修改的时候理赔单引用的登记单的ID
 * refId 在修改的时候理赔单引用的登记单的单号
 */
export default {
    props:{
        registerId: String,
        refId: String,
    },
    data () {
        return {
            radio:null,
            dialogVisible: false,
            quotes: [],
            currentPage: 1,
            totalPage: 1,
            hiddenRef: true,
            currentRef: null,
            tempQuoates: [],
            loadingData: true,
            customer: null,
            pagesize:20,
            is_yingcang: 1
        }
    },
    watch:{
        hiddenRef (newVaule, oldValue) {
            if (newVaule) {
                this.is_yingcang = 1
            } else {
                this.is_yingcang = 0
            }
            this.queryData(1);
        }
    },
    methods:{
        getCurrentRow (row) {
            this.currentRef = row;
        },     
        formatter (row, column, cellValue) {
            if (parseInt(row.is_xuanzhong) === 1 && !this.radio) {
                this.radio = row.guanlian_transaction_no;
            } 
            return parseInt(row.is_yinyong) === 1 ? "引用完成" : "未引用";
        },
        queryData (page) {
            this.$api['tgcQuote'].query({
                "dengji_id": this.registerId,
                "guanlian_transaction_no": this.refId,
                "page": page,
                "perpage": this.pagesize,
                "customer_id": this.customer,
                "is_yingcang": this.is_yingcang,
                }).then((rs) => {
                if (rs.data.length >= 0) {
                    this.currentPage = rs.current;
                    this.totalPage = rs.total;
                    this.tempQuoates = rs.data;
                    this.filterRef();
                }
                this.loadingData = false;
            });
        },
        filterRef () {
            this.quotes = this.hiddenRef ? this.tempQuoates.filter((ele) => {
                return parseInt(ele.is_yinyong) === 0;
            }) : this.tempQuoates; 
        },
        open (cid) {
            this.customer = cid;
            this.loadingData = true;
            this.currentPage = 1;
            this.totalPage = 1;
            this.quotes = [];
            this.queryData(1)
            this.dialogVisible = true;
            this.currentRef = null
        },
        addRef () {
            this.$emit("complete",this.currentRef);
            this.dialogVisible = false;
        }
    }
}
</script>
